import {Property} from "./property";
import {BillingAdress} from "./billingAdress";
import {NotificationSettings} from "./notificationSettings";
import {OrderStatistics} from "./order-statistics";

import { PermissionEntry } from "./permissionEntry";
import {BillingPositionBody} from "./billing-position-body";

export class Order {
  orderid: string;
  orderedByUserId: string;
  entrydate: string;
  name: string;
  info: string;
  properties: Array<Property>
  billingAdress: BillingAdress;
  notificationSettings: NotificationSettings;
  orderStatistics: OrderStatistics;
  permission: PermissionEntry | null;
  companyLoginId: string | null;
  userid: string;
  archived: boolean;
  positionBodies: BillingPositionBody[];
  origin: string;
}
